// Group consecutive same-type notifications into one summary row (WhatsApp/Instagram style).
export const GROUPABLE_TYPES = new Set(["security", "follow", "reaction", "comment"]);
// Profil privé : une demande d'abonnement (Accepter / Refuser) ou sa réponse reste une ligne à part, jamais fondue dans « N nouveaux abonnés ».
const STANDALONE_KINDS = new Set(["follow_request", "follow_request_done", "follow_accepted"]);
const groupable = (n) => GROUPABLE_TYPES.has(n.type) && !STANDALONE_KINDS.has(n.meta?.kind);

export const groupNotifications = (items) => {
  const out = [];
  let i = 0;
  while (i < (items || []).length) {
    const cur = items[i];
    if (groupable(cur)) {
      let j = i + 1;
      const group = [cur];
      while (j < items.length && items[j].type === cur.type && groupable(items[j])) { group.push(items[j]); j++; }
      if (group.length >= 2) {
        out.push({ __group: true, type: cur.type, id: `grp-${cur.type}-${cur.id}`, items: group });
        i = j;
        continue;
      }
    }
    out.push(cur);
    i++;
  }
  return out;
};

export const groupTitle = (type, n, t) => {
  const key = GROUPABLE_TYPES.has(type) ? `notif.group.${type}` : "notif.group.default";
  const fb = {
    security: "{n} nouvelles connexions",
    follow: "{n} nouveaux abonnés",
    reaction: "{n} nouvelles réactions",
    comment: "{n} nouveaux commentaires",
  }[type] || "{n} notifications";
  return (t(key, fb) || fb).replace("{n}", n);
};
